var echarts = require("../echarts");

require("../coord/single/singleCreator");

require("./axis/SingleAxisView");

require("../coord/single/AxisModel");

require("./axisPointer");

require("./axisPointer/SingleAxisPointer");

echarts.extendComponentView({
  type: 'single'
});


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/singleAxis.js
// module id = 246
// module chunks = 0